import type { Space } from '@cocoonspace/sdk-js/types/space'
import { useEmitter } from '@cocoonspace/shared/hooks/use-emitter.hook'
import { useState } from 'react'

import { Dialog, DialogContent } from '~/components/ui/dialog'
import { SpaceDetailsImageCarousel } from '~/domains/spaces/components/space-details/space-details-images-carousel'
import {
	type SpaceCarouselPayload,
	dialogsEmitter,
} from '~/domains/spaces/emitters/dialog.emitter'

export const SpaceDialogCarousel = ({ space }: { space: Space }) => {
	const [show, setShow] = useState(false)

	const [galleryOpts, setGalleryOpts] = useState<
		SpaceCarouselPayload | undefined
	>({ index: 0 })

	const openDialog = (payload?: SpaceCarouselPayload) => {
		setShow(true)
		setGalleryOpts(payload)
	}

	const closeDialog = () => {
		setShow(false)
	}

	useEmitter(dialogsEmitter, {
		'spaceCarousel.open': openDialog,
		'spaceCarousel.close': closeDialog,
	})

	return (
		<Dialog
			open={show}
			onOpenChange={setShow}
		>
			<DialogContent className='!max-w-full !rounded-none h-screen w-screen'>
				<SpaceDetailsImageCarousel
					galleryOpts={galleryOpts}
					space={space}
					className='flex h-full items-center'
					onClose={closeDialog}
				/>
			</DialogContent>
		</Dialog>
	)
}
